// removed by extract-text-webpack-plugin
module.exports = {"breakpointSmall":"767px","breakpointMedium":"1023px"};


//////////////////
// WEBPACK FOOTER
// ./src/frontend/entry-points/content-page/content-page.scss
// module id = 101
// module chunks = 5